import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { FullWidthLayout, SectionLayout } from "@/layouts";
import dynamic from "next/dynamic";
const ArrowOutwardIcon = dynamic(() => import("@mui/icons-material/ArrowOutward"), { ssr: false });
import { ButtonMui } from "@/components/ui";
import * as Styled from "./support.styles";
import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@cellectenergy/cellect-react-components";

interface SupportPartnerProps {
  name: string;
  email: string;
  position: string;
  image: string;
}

export const SupportPartner: FC<SupportPartnerProps> = ({
  name,
  email,
  position,
  image,
}) => {
  const { t } = useTranslation("global");
  const theme = useTheme();
  return (
    <FullWidthLayout
      id="signUp"
      bgColor={theme.palette.common.corporateColors.primary.midNightBlue}
    >
      <SectionLayout>
        <Styled.MainSupportContainer
          bgcolor={theme.palette.common.corporateColors.primary.midNightBlue}
        >
          <Grid
            container
            columnSpacing={{ xs: "0", md: "0", lg: "1.25rem" }}
            gap={{ xs: "1.5rem", sm: "0", md: "0" }}
            padding={{ xs: "2rem 0", md: "2rem 0", lg: "3rem 0" }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                color={theme.palette.common.corporateColors.primary.white}
                variant="display-small"
                fontWeight={500}
                width={{ xs: "100%", md: "75%", lg: "72%" }}
                display="flex"
              >
                {t(`support.${position}.title`)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Styled.InnerContainer>
                <Box>
                  <Typography
                    variant="body-large"
                    color={theme.palette.common.corporateColors.primary.white}
                  >
                    {t(`support.${position}.description`)}
                  </Typography>
                </Box>
                <Styled.HeroContainer>
                  <Box>
                    <Styled.Img src={image} alt={name} />
                  </Box>
                  <Styled.ContactInfo>
                    <Typography
                      color={theme.palette.common.corporateColors.primary.white}
                      variant="body-large"
                      fontWeight={500}
                    >
                      {name}
                    </Typography>
                    <Typography
                      color={theme.palette.common.corporateColors.primary.white}
                      variant="body-large"
                    >
                      {email}
                    </Typography>
                  </Styled.ContactInfo>
                </Styled.HeroContainer>
                <Styled.BtnContainer>
                  {position !== "specialist" ? (
                    <ButtonMui
                      variant="contained"
                      sx={{
                        width: {
                          xs: "100% !important",
                          md: "14.18rem !important",
                          lg: "20.68rem !important",
                        },
                        color:
                          theme.palette.common.corporateColors.primary
                            .midNightBlue,
                        backgroundColor:
                          theme.palette.common.corporateColors.secondary
                            .turquoise,
                      }}
                      endIcon={<ArrowOutwardIcon />}
                      size="medium"
                    >
                      <a
                        href="https://calendly.com/olivier-luescher/30min"
                        rel="noreferrer noopener"
                        target={"_blank"}
                      >
                        {t("support.expert.btnSchedule")}
                      </a>
                    </ButtonMui>
                  ) : null}
                </Styled.BtnContainer>
              </Styled.InnerContainer>
            </Grid>
          </Grid>
        </Styled.MainSupportContainer>
      </SectionLayout>
    </FullWidthLayout>
  );
};
